import {gql} from "@apollo/client";

export const GET_TOURS_LIST = gql`
    query getToursList($month: Int!, $year: Int!) {
        getToursList(month: $month, year: $year) {
            _id
            title
            tourTitle
            bookingDate
            totalCustomers
            language
            bookings {
                _id
                bookingCode
                bookingDate
                status
                language
                priceNet
                client {
                    clientName
                    clientCountry
                    clientPhone
                    clientEmail
                    clientAdult
                    clientChild
                    clientEnfant
                    clientYouth
                }
            }
            guide {
                _id
                profile {
                    firstName
                    lastName
                }
                isConfirmedByGuide
                isConfirmedDate
            }
            coordinator {
                _id
                profile {
                    firstName
                    lastName
                }
            }
            isConfirmedByGuide
            isConfirmedDate
        }
    }
`;

export const GET_TOUR_ITEMS_LIST = gql`
    query getTourItemsList {
        getTourItemsList {
            _id
            title
        }
    }
`;

export const GET_TOURS_LABEL_LIST = gql`
    query getTourLabelsList {
        getTourLabelsList {
            _id
            title {
                _id
                title
            }
            maxClients
            price
        }
    }
`;


export const ADD_TOUR_ITEM = gql`
    mutation addTourItem($tourItemInput: TourItemInput!) {
        addTourItem(tourItemInput: $tourItemInput)
    }
`;

export const ADD_TOUR_LABEL = gql`
    mutation addTourLabel($tourLabelInput: TourLabelInput!) {
        addTourLabel(tourLabelInput: $tourLabelInput)
    }
`;

export const ADD_TOUR = gql`
    mutation addTour($tourInput: TourInput!) {
        addTour(tourInput: $tourInput)
    }
`;

export const UPDATE_TOUR_GUIDES = gql`
    mutation updateTourGuides($tourUpdateGuidesInput: TourUpdateGuidesInput!){
        updateTourGuides (tourUpdateGuidesInput: $tourUpdateGuidesInput)}
`;

export const UPDATE_TOUR_COORDINATORS = gql`
    mutation updateTourCoordinators($tourUpdateCoordinatorsInput: TourUpdateCoordinatorsInput!) {
        updateTourCoordinators(tourUpdateCoordinatorsInput: $tourUpdateCoordinatorsInput)
    }
`;

export const UPDATE_TOUR_LANGUAGE = gql`
    mutation updateTourLanguage($tourUpdateLanguageInput: TourUpdateLanguageInput!) {
        updateTourLanguage(tourUpdateLanguageInput: $tourUpdateLanguageInput)
    }
`;

export const CONFIRM_TOUR_BY_GUIDE = gql`
    mutation confirmTourByGuide($tourConfirmationInput: TourConfirmationInput!) {
        confirmTourByGuide(tourConfirmationInput: $tourConfirmationInput)
    }
`;

export const REMOVE_BOOKING_FROM_TOUR = gql`
    mutation removeBookingFromTour($tourBookingInput: TourBookingInput!) {
        removeBookingFromTour(tourBookingInput: $tourBookingInput)
    }
`;

export const DELETE_TOUR = gql`
    mutation deleteTour($tourDeleteInput: TourDeleteInput!) {
        deleteTour(tourDeleteInput: $tourDeleteInput)
    }
`;

export const GET_COORDINATOR_TOURS = gql`
    query getCoordinatorTours($month: Int, $year: Int) {
        getCoordinatorTours(month: $month, year: $year) {
            _id
            bookingDate
            tourTitle
            guests {
                clientName
                clientAdult
                clientChild
                clientYouth
                clientEnfant
            }
        }
    }
`;
